module.exports = __webpack_public_path__ + "static/img/live_tu44.70a91da.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/live_tu44.png
// module id = gGnZ
// module chunks = 1